module.exports = require('./GridSpinnerView');
